module.exports = require('./GridSpinnerView');
